import useValidator from 'utils/hooks/useValidator'
import {
  invalidNumberInput,
  isEmpty,
  premiumLinkRegex,
  talkChannelRegex,
} from 'utils'
import { useSelector } from 'react-redux'
import { noneTime } from '../../../../components/TimeTable'
import { CampaignTypes } from '../../../Codes'

const useAdGroupValidator = () => {
  const {
    campaign: {
      form: {
        campaignType,
        dailyBudgetYn: campaignDailyBudgetYn,
        dailyBudgetAmount: campaignDailyBudgetAmount,
      },
    },
    adGroup: {
      form: {
        name,
        placementType,
        placementCategories,
        deviceSettingType,
        deviceTypes,
        keywordExtensionYn,
        exceptionKeywords,
        maxBiddingAmount,
        dailyBudget,
        mobileWeight,
        pcWeight,
        keywordExtensionWeight,
        contentMatchingMaxBiddingAmount,
        customContentMatchingMaxBiddingAmountYn,
        startDate,
        endDate,
        weeklySchedule,
        endDateDisabled,
        impressionAll,
      },
    },
  } = useSelector(state => state.ad)
  const { errors, validate, addError } = useValidator(
    () => ({
      name: isEmpty(name) && '광고그룹 이름을 입력하세요.',
      placement:
        campaignType === CampaignTypes.PREMIUM_LINK &&
        placementType === 'SETTING' &&
        isEmpty(placementCategories) &&
        '매체유형 상세설정에 선택된 값이 없습니다.',
      device:
        campaignType === CampaignTypes.PREMIUM_LINK &&
        deviceSettingType === 'SETTING' &&
        isEmpty(deviceTypes) &&
        '디바이스 상세설정에 선택된 값이 없습니다.',
      exceptionKeywords:
        (keywordExtensionYn === 'Y' &&
          (campaignType === CampaignTypes.PREMIUM_LINK
            ? exceptionKeywords.some(item => !premiumLinkRegex.test(item)) && (
                <>
                  제외키워드에 입력 불가능한 문자가 입력되어 있습니다.
                  <br />
                  (특수문자 일부, 한자 입력 불가능)
                </>
              )
            : exceptionKeywords.some(item => !talkChannelRegex.test(item)) && (
                <>
                  제외키워드에 입력 불가능한 문자가 입력되어 있습니다.
                  <br />
                  (한글, 영문, 숫자, 특수문자 일부, 띄어쓰기 외 입력 불가)
                </>
              ))) ||
        (keywordExtensionYn === 'Y' &&
          (campaignType === CampaignTypes.PREMIUM_LINK
            ? exceptionKeywords.some(item => item.length > 50) &&
              '제외키워드는 1자이상 50자 이하여야 합니다.'
            : exceptionKeywords.some(
                item => item.length > 50 || item.length < 2
              ) && '제외키워드는 2자이상 50자 이하여야 합니다.')),
      maxBiddingAmount:
        campaignType === CampaignTypes.PREMIUM_LINK &&
        ((maxBiddingAmount === '' && '기본입찰가를 입력해주세요.') ||
          (invalidNumberInput(maxBiddingAmount, 100000, 70, 10) &&
            '기본입찰가는 최소 70원 ~ 최대 100,000원까지 10원 단위로 설정해주세요.')),
      dailyBudget:
        (dailyBudget === '' && '일예산을 입력하세요.') ||
        (invalidNumberInput(dailyBudget, 10000000, 1000, 10) &&
          '광고그룹 일예산은 최소 1,000원 ~ 최대 1천만원까지 10원 단위로 설정할 수 있습니다.') ||
        (campaignDailyBudgetYn === 'Y' &&
          campaignDailyBudgetAmount &&
          Number(dailyBudget) > Number(campaignDailyBudgetAmount) &&
          `광고그룹 일예산은 상위 캠페인 일예산(${Number(
            campaignDailyBudgetAmount
          ).toLocaleString()}원) 이하로 설정할 수 있습니다.`),
      mobileWeight:
        campaignType === CampaignTypes.PREMIUM_LINK &&
        (mobileWeight === '' || invalidNumberInput(mobileWeight, 500, 10, 1)) &&
        true,
      pcWeight:
        campaignType === CampaignTypes.PREMIUM_LINK &&
        (pcWeight === '' || invalidNumberInput(pcWeight, 500, 10, 1)) &&
        true,
      deviceWeight:
        campaignType === CampaignTypes.PREMIUM_LINK &&
        (((mobileWeight === '' || pcWeight === '') && (
          <>
            디바이스 입찰가중치가 입력되지 않았습니다.
            <br />
            기본입찰가 사용을 원하실 경우 100%를 입력하세요.
          </>
        )) ||
          ((invalidNumberInput(mobileWeight, 500, 10, 1) ||
            invalidNumberInput(pcWeight, 500, 10, 1)) &&
            '모바일/PC 입찰 가중치는 최소 10%부터 최대 500%내에서 설정해주세요.')),
      keywordExtensionWeight:
        campaignType === CampaignTypes.PREMIUM_LINK &&
        ((keywordExtensionWeight === '' && (
          <>
            키워드확장 입찰가중치가 입력되지 않았습니다.
            <br />
            기본입찰가 사용을 원하실 경우 100%를 입력하세요.
          </>
        )) ||
          (invalidNumberInput(keywordExtensionWeight, 500, 10, 1) &&
            '키워드확장 입찰 가중치는 최소 10%부터 최대 500%내에서 설정해주세요.')),
      contentMatchingMaxBiddingAmount:
        campaignType === CampaignTypes.PREMIUM_LINK &&
        customContentMatchingMaxBiddingAmountYn === 'Y' &&
        (contentMatchingMaxBiddingAmount === '' ||
          invalidNumberInput(
            contentMatchingMaxBiddingAmount,
            100000,
            70,
            10
          )) &&
        '콘텐츠 매체 입찰가는 최소70원~ 최대 100,000원까지 10원 단위로 설정해주세요.',
      date:
        (!endDateDisabled && (endDate === '' || endDate === null) && (
          <>
            종료일을 설정해주세요.
            <br />
            종료일없이 설정하실 경우 종료일 미설정을 선택하세요.
          </>
        )) ||
        (!endDateDisabled && startDate > endDate && (
          <>
            종료일은 시작일보다 앞설 수 없습니다.
            <br />
            시작일 이후의 날짜를 선택해주세요.
          </>
        )),
      weeklySchedule: !impressionAll && weeklySchedule === noneTime && (
        <>
          집행기간의 요일/시간 설정을 확인하세요.
          <br />
          반드시 한 개 이상 설정해야 합니다.
        </>
      ),
    }),
    [
      campaignType,
      campaignDailyBudgetYn,
      campaignDailyBudgetAmount,
      name,
      placementType,
      placementCategories,
      deviceSettingType,
      deviceTypes,
      keywordExtensionYn,
      exceptionKeywords,
      maxBiddingAmount,
      dailyBudget,
      mobileWeight,
      pcWeight,
      keywordExtensionWeight,
      contentMatchingMaxBiddingAmount,
      customContentMatchingMaxBiddingAmountYn,
      startDate,
      endDate,
      weeklySchedule,
      endDateDisabled,
      impressionAll,
    ]
  )
  return {
    errors,
    validate,
    addError,
  }
}

export default useAdGroupValidator
